import React from "react";
import { Box, Button, Typography } from "@material-ui/core";
import CDialog from "shared/CDialog";
import { Exercises } from "routes/createContent/views/exercises/Exercises";
import { TemplateFormExercise, buildFormExerciseFromLibrary } from "../types";
import ExercisePreviewDialog from "./ExercisePreviewDialog";
import { usePickerSelection } from "./usePickerSelection";

type Props = {
  open: boolean;
  onClose: () => void;
  existingIds: number[];
  onAdd: (exercises: TemplateFormExercise[]) => void;
};

// Reuses the full Exercises page (filters, search, pagination) in picker mode,
// with the view/edit/delete/state controls hidden. Selection is tracked here
// and added to the template on confirm.
const ExercisePickerDialog: React.VFC<Props> = ({ open, onClose, existingIds, onAdd }) => {
  const { previewId, setPreviewId, checkedIds, toggle, count, selectedItems } = usePickerSelection<
    any,
    TemplateFormExercise
  >(open, existingIds, ex => ex.exercise_id, buildFormExerciseFromLibrary);

  const handleAdd = () => {
    onAdd(selectedItems());
    onClose();
  };

  return (
    <>
      <CDialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
        <Box px={3} pb={2}>
          <Typography variant="h6" gutterBottom>
            Add exercises
          </Typography>
          <Exercises pickerMode checkedIds={checkedIds} onPickToggle={toggle} onPreview={setPreviewId} />
        </Box>
        <Box
          px={3}
          py={2}
          display="flex"
          justifyContent="flex-end"
          style={{ gap: 12, position: "sticky", bottom: 0, background: "#fff", borderTop: "1px solid #e0e0e0" }}
        >
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="contained" color="primary" disabled={count === 0} onClick={handleAdd}>
            Add {count > 0 ? count : ""} exercise{count === 1 ? "" : "s"}
          </Button>
        </Box>
      </CDialog>
      <ExercisePreviewDialog exerciseId={previewId} onClose={() => setPreviewId(null)} />
    </>
  );
};

export default ExercisePickerDialog;
